module.exports = __webpack_public_path__ + "img/logo.78be6c2.svg";